export class HighFrequencyBackupScheduleConfig {
    'frequency';
    'intervalConfig';
    'dailyConfig';
    'weeklyConfig';
    'monthlyConfig';
    'annuallyConfig';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "frequency",
            "baseName": "frequency",
            "type": "HighFrequencyBackupScheduleFrequency",
            "format": ""
        },
        {
            "name": "intervalConfig",
            "baseName": "intervalConfig",
            "type": "HighFrequencyIntervalConfig",
            "format": ""
        },
        {
            "name": "dailyConfig",
            "baseName": "dailyConfig",
            "type": "DailyConfig",
            "format": ""
        },
        {
            "name": "weeklyConfig",
            "baseName": "weeklyConfig",
            "type": "WeeklyConfig",
            "format": ""
        },
        {
            "name": "monthlyConfig",
            "baseName": "monthlyConfig",
            "type": "MonthlyConfig",
            "format": ""
        },
        {
            "name": "annuallyConfig",
            "baseName": "annuallyConfig",
            "type": "AnnuallyConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return HighFrequencyBackupScheduleConfig.attributeTypeMap;
    }
    constructor() {
    }
}
